import React from "react";

const LegalIP = () => (
  <section className="w-full bg-white py-8 px-6">
    <h2 className="text-xl font-bold text-dark-1 mb-4">3. Propriété intellectuelle</h2>
    <p className="text-light-1 leading-relaxed">
      L’ensemble des contenus présents sur le site <strong>NextMaker</strong> (textes, images, vidéos, logos,
      illustrations, ressources pédagogiques, etc.) sont protégés par le droit d’auteur et la propriété intellectuelle.
    </p>
    <p className="text-light-1 mt-3">
      Toute reproduction, représentation, modification ou diffusion sans autorisation est interdite. <br />
      👉 Cependant, certains contenus pédagogiques peuvent être proposés sous{" "}
      <strong>licences ouvertes (Creative Commons, MIT, etc.)</strong>.
    </p>
  </section>
);

export default LegalIP;
